import React, { useEffect } from "react";

const Upgrade = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Escolha seu plano</h2>
      <stripe-pricing-table
       pricing-table-id="prctbl_1RGkjKD3dwBeHliK1TFD9Mpe"
       publishable-key="pk_live_51QfT9AD3dwBeHliKQ4vrzgMOo5sM7voU6k027oR7tcLthlhMzU1moNS7MCKOX01KlsOyEmvEUphlapzkkU24tkBR00BvnWGZxZ">
      </stripe-pricing-table>
    </div>
  );
};

export default Upgrade;



